import { render, staticRenderFns } from "./EditDealsAndSpeacialsComponent.vue?vue&type=template&id=394a0050&"
import script from "./EditDealsAndSpeacialsComponent.vue?vue&type=script&lang=js&"
export * from "./EditDealsAndSpeacialsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports